import React, { Fragment } from 'react';
import { UrlEnum } from '../../../shared';
import format from "date-fns/format";
import { useHistory } from "react-router-dom";
export const AwaitingResponseTab = ({ data }) => {
    const formatCreatedDate = createdDate => {
        if (createdDate == null) return <Fragment></Fragment>;
        const date = new Date(createdDate);
        return <Fragment>{format(date, 'M/d/yyyy')}</Fragment>;
    };
    const history = useHistory();
    return (
        <div
            className="tab-pane fade show active"
            id="awaitingResponse"
            role="tabpanel"
            aria-labelledby="awaitingResponse-tab"
        >
            {data?.map(req => (
              <a
                className="card request-card action mb-3"
                onClick={() => {
                    const location = {
                        pathname:
                        UrlEnum.INSTITUTION_VIEW_ACADEMIC_PROGRAM_REQUESTS,
                        state: [
                            {
                                data: req,
                            },
                        ],
                    };
                    history.push(location);
                }}
              >
                  <div className="row align-items-center justify-content-between">
                      <div className="col-md mb-3 mb-md-0">
                          <p className="text-muted text-italic mb-2">
                              {req.description} submitted{' '}
                              {formatCreatedDate(req.createdOn)}
                          </p>
                          <div className="ml-2">
                              <h2 className="text-600 text-primary mb-1">
                                  {req.programName}
                              </h2>
                          </div>
                      </div>
                      <div className="col-md-auto">
                          {req.status === 'Awaiting Institution' && (
                            <div className="d-flex align-items-center">
                                <h2 className="mb-0 mr-4">
                                                <span className="badge badge-round badge-danger p-2">
                                                    <i className="fas fa-exclamation-circle"></i>{' '}
                                                    Action Required
                                                </span>
                                </h2>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary request-card-btn"
                                >
                                    Edit
                                </button>
                            </div>
                          )}
                          {req.status === 'Submitted' && (
                            <div className="d-flex align-items-center">
                                <h2 className="mb-0 mr-4">
                                                <span className="badge badge-round badge-light-gray p-2">
                                                    Submitted
                                                </span>
                                </h2>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary request-card-btn"
                                >
                                    Edit
                                </button>
                            </div>
                          )}
                          {req.status === 'Under Review' && (
                            <div className="d-flex align-items-center">
                                <h2 className="mb-0 mr-4">
                                                <span className="badge badge-round badge-light-orange p-2">
                                                    Under Review
                                                </span>
                                </h2>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary request-card-btn"
                                >
                                    View
                                </button>
                            </div>
                          )}
                          {(req.status === 'Denied' ||
                            req.status === 'Approved') && (
                            <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <h2 className="mb-0 mr-4">
                                                    <span className="badge badge-round badge-light-gray p-2">
                                                        {req.status}
                                                    </span>
                                    </h2>
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary request-card-btn"
                                    >
                                        View
                                    </button>
                                </div>
                            </div>
                          )}
                      </div>
                  </div>
              </a>
            ))}
        </div>
    );
};
